import { URLS } from "../config";
import { logoutHandler } from "./logoutHandler";
import { Dispatch } from "@reduxjs/toolkit";
import { NavigateFunction } from "react-router-dom";
import { toast } from 'react-toastify';
import { actions } from "../store/actions";


export const discountCodeInquery = async (
  data: { items: any[], discount_code:string},
  token: string,
  dispatch: Dispatch,
  navigate: NavigateFunction
) => {
  const response = await fetch(URLS.DISCOUNT_INQUERY, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `JWT ${token}`,
    },
    body: JSON.stringify(data),
  });

  if (response.status === 401) {
    logoutHandler(dispatch, navigate); // خروج از سیستم و ریدایرکت به login
    return;
  }

  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'خطا در پردازش کد');
  }
  const response_data = await response.json();
  dispatch(actions.setDiscount(response_data.discount_price))
  dispatch(actions.setPromoCode(data.discount_code))
  toast.success(`مبلغ ${response_data.discount_price} تخفیف با موفقیت به سبد شما اعمال شد`);
  return response_data;
};